import DateInput from "../../../components/common/inputs/DateInput";
import { useRef, useState } from "react";
import UserModal from "../../../components/common/modals/user-modal/UserModal";
import { PiXFill } from "react-icons/pi";
import { successMessage } from "../../../utils/toastify-message/ToastifyMessage";

export default function UserCustomersReportsFilter({ filterDataHandler }) {
  const userModalRef = useRef();
  const [user, setUser] = useState(null);
  const [filters, setFilters] = useState({ from: "", to: "", user: "" });

  const handleUser = (data) => {
    setUser(data.name);
    setFilters((prev) => ({
      ...prev,
      userMobile: data.mobile,
      userId: data._id,
    }));
    successMessage(`کاربر ${data?.name} انتخاب شد`);
  };

  const deleteUser = () => {
    setUser("");
    setFilters((prev) => ({ ...prev, user: "" }));
  };

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const handleSearch = () => {
    filterDataHandler({ page: 1, ...filters });
  };

  return (
    <div className="w-full flex flex-col flex-wrap my-8 gap-6 px-6">
      <UserModal ref={userModalRef} handleUser={handleUser} />

      <div className="w-full items-center justify-center sm:justify-start flex flex-col sm:flex-row gap-6">
        <DateInput
          label={"از تاریخ"}
          onChange={(e) => handleFilterChange("from", e)}
        />
        <DateInput
          label={"تا تاریخ"}
          onChange={(e) => handleFilterChange("to", e)}
        />
        <div className="relative">
          <span
            onClick={() => userModalRef?.current?.showModal()}
            className="absolute w-full h-full"
          ></span>
          {user ? (
            <PiXFill
              className="cursor-pointer absolute left-2 bottom-4 text-red-500"
              onClick={deleteUser}
            />
          ) : null}
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            انتخاب کاربر
          </label>
          <input
            value={user}
            disabled
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          />
        </div>
        <button
          className="text-white mt-[30px] h-10 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-8  text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          onClick={handleSearch}
        >
          جستجو
        </button>
      </div>
    </div>
  );
}
